<template>
  <div class="color__picker">
        <label :for="id">{{label}}</label>
        <input type="color" :id="id" :name="name" :value="value" @input="getColor($event)">
  </div>
</template>

<script>
export default {
    props : {
        id : { type : String | Number, default:'color'},
        name : { type : String, default:'color'},
        label : { type : String, default:'color'},
        value : { type : String, default:"#e66465"},
    },
    methods : {
        getColor(e) {
            this.$emit('input',e.target.value)
        }
    }
}
</script>

<style lang="scss" scoped>
    .color__picker {
        display: flex;
        align-items: center;
    }

</style>


// WEBPACK FOOTER //
// src/components/global/ColorPicker.vue